import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import {
  SuperDropdownComponent,
  DropdownItem,
} from '../shared/super-dropdown/super-dropdown.component';
@Component({
  selector: 'app-user-details',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    RouterModule,
    MatDividerModule,
    SuperDropdownComponent,
  ],
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css'],
})
export class UserDetailsComponent {
  user = {
    name: 'Jane Doe',
    avatarUrl: '', // Or provide a mock URL for avatar image
  };

  dropdownItems: DropdownItem[] = [
    { label: 'Profile', icon: 'person', action: 'profile' },
    { label: 'Settings', icon: 'settings', action: 'settings' },
    { divider: true },
    { label: 'Logout', icon: 'logout', action: 'logout' },
  ];

  handleDropdownAction(action: string) {
    if (action === 'logout') {
      this.logout();
    } else if (action === 'profile') {
      // Implement navigation to profile if desired
    } else if (action === 'settings') {
      // Implement navigation to settings if desired
    }
  }

  isDropdownOpen = true;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  logout() {
    // Mock logout logic
    alert('Logged out!');
  }
}
